import { ShopifyInstance, ShopifyInstanceIdentifierEnum } from './config'
import { SelectedOption } from './types'

const ignoredOptions: Readonly<string[]> = ['Job', 'Color']

export const selectedOptionsString = (selectedOptions: SelectedOption[], fallback?: string) => {
  return (
    selectedOptions
      ?.filter((option) => !ignoredOptions.includes(option.name))
      ?.map((option) => `${option.name}: ${option.value}`)
      ?.join(' - ') || fallback
  )
}

/**
 * Re-label an option. E.g. if it's a size option, rename 'EUR38' to '38'. From
 * a fulfillment perspective, one needs 'EUR38', but from a visitor perspective,
 * '38' will be just fine.
 *
 * Remember to only use this for cosmetic purposes!
 */
export const improveOptionValue = (name: SelectedOption['name'], value: SelectedOption['value'], shopifyInstance: ShopifyInstance): Readonly<string> => {
  if (name.toLowerCase() === 'size') {
    if (shopifyInstance.id === ShopifyInstanceIdentifierEnum.EUR) {
      // Convert 'EUR38' to '38'
      return value.replace('EUR', '')
    } else if (shopifyInstance.id === ShopifyInstanceIdentifierEnum.GBP) {
      // Convert 'UK2 - 35' to '2'
      return value.replace('UK', '').split('-')?.[0]?.trim() || value
    } else if (shopifyInstance.id === ShopifyInstanceIdentifierEnum.USD) {
      // Convert 'US5 - EUR35' to '5'
      return value.replace('US', '').split('-')?.[0]?.trim() || value
    }
  }

  return value
}
